import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EnvioDeMailGenerico } from '@shared/models/notificaciones/EnvioDeMailGenerico';
import { MessageService } from '@shell/message.service';
import { ClienteService } from '../cliente.service';
import { CustomValidatorsService } from '@shared/validators/custom-validators.service';

@Component({
  selector: 'app-modal-envio-mail',
  templateUrl: './modal-envio-mail.component.html',
  styleUrls: ['./modal-envio-mail.component.css']
})
export class ModalEnvioMailComponent {

  envioMail: UntypedFormGroup;
  arrayMails: string[] = [];
  enviandoMail: boolean = false;


  constructor(
    public activeModal: NgbModal, 
    private clienteService: ClienteService, 
    private messageService: MessageService,
    fb: UntypedFormBuilder) {
      this.envioMail = fb.group({
        email: new UntypedFormControl(null, [Validators.required, CustomValidatorsService.emailValidator])
      });
  }

  enviarMail() {
    this.enviandoMail = true;
    if(this.arrayMails.length > 0){
    const mail = new EnvioDeMailGenerico();
    mail.Emails = [];
    mail.Emails = this.arrayMails;
    mail.asuntoCorreo = 'Información para alta de nuevo';
    mail.cuerpoHtml = "<p>Se debera enviar la informacion detalla debajo al E-mail de YPF mail@mail.com.ar:</p><br><ul><li>Constancia de inscripción de AFIP.</li><li>Constancia de inscipción para la percepción de IIBB para las provincias que se encuentre inscripto.</li><li>Constancia de inscripción percepcion de IVA diferencia indicando alicuota y fecha de caducidad.</li></ul>"
    this.clienteService.enviarMail(mail)
      .subscribe(() => {
        this.messageService.showSuccessMessage('El mail fue enviado con exito.');
        this.enviandoMail = false;
        this.activeModal.dismissAll();
      }, () => {
        this.messageService.showErrorMessage('Hubo un error al enviar el mail, verifique las casillas ingresadas.');
        this.enviandoMail = false;
      });
    }else{
      this.messageService.showErrorMessage('Debe agregar al menos un mail para enviar.');
      this.enviandoMail = false;
    }
  }

  agregarMail() {
    if (this.email.value) {
      this.arrayMails.push(this.email.value);
      this.email.setValue(null);
    }
  }

  desasignarMail(mail: string){
    const index: number = this.arrayMails.indexOf(mail);
    if (index !== -1) {
      this.arrayMails.splice(index, 1);
    }
  }

  get email() {
    return this.envioMail.get('email');
  }

}
